import { Divider, message } from 'antd';
import { Loader } from '@mantine/core';
import React, { useRef } from 'react';
import { useQuery } from 'react-query';
import { getExcuseDuty } from '../../helpers/api';
import { excuseDutyDays } from '../../helpers/utilities';
import { useReactToPrint } from "react-to-print";
import { getUser } from '../../helpers/auth';
import { usePDF } from "react-to-pdf";


export function ExcuseDutyDisplay({ code, excuseDutyId }) {

    const { data = {}, isFetching, isError } = useQuery({
        queryFn: () => getExcuseDuty(code, excuseDutyId),
        queryKey: ['excuse-duty', code, excuseDutyId],
    });

    const printArea = useRef();
    const { toPDF, targetRef } = usePDF({ filename: `excuse-duty-${code}.pdf` });


    const handlePrint = useReactToPrint({
        content: () => printArea.current,
        documentTitle: "excuse duty - " + code,
        copyStyles: true,
        // bodyClass: "sale-receipt"
    });



    return (
        <div>
            {
                isFetching ?
                    <div className="text-center"><Loader /> please wait...</div>
                    :
                    isError ?
                        <kbd className="bg-danger p-2">Sorry, we encountered an error processing your request</kbd>
                        :
                        <>
                            <div className="buttons has-addons mt-3">
                                <button id="submit" className="button app-btn btn-prim"
                                    onClick={() => {
                                        message.info('downloading...');
                                        toPDF();
                                    }}
                                >
                                    <span className="bi bi-file-pdf me-2"></span>
                                    Download PDF
                                </button>
                                <button id="submit" className="button app-btn" onClick={handlePrint}>
                                    <span className="bi bi-printer me-2"></span>
                                    Print
                                </button>
                            </div>
                            <Divider />
                            <div id="printRegion" ref={printArea}>
                                <div ref={targetRef}>
                                    <div className="row app-bg-primary">
                                        <div className="col-12 p-5 pb-0">
                                            <h1 className='mb-0 pb-0'>{getUser()?.facility?.facilityName}</h1>
                                            {/* <p className='mt-0 pt-1'>
                                            { getUser().facility?.address }
                                        </p> */}
                                            <Divider />
                                            <div className="mt-2">
                                                <h5 className='mb-0'>EXCUSE DUTY</h5>
                                                <p>Consultation tracking code is: <kbd>{code}</kbd></p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <Divider className='mb-0' /> */}
                                    <div className="p-5">
                                        <div className="row">
                                            <div className="col-3"><strong>Patient:</strong></div>
                                            <div className="col-7">
                                                <div>{`${data?.patient?.firstName} ${data?.patient?.lastName}`}</div>
                                                {data?.patient?.gender && (
                                                    <div className="text-muted small">{data.patient.gender}</div>
                                                )}
                                                {data?.patient?.contact && (
                                                    <div className="text-muted small">{data.patient.contact}</div>
                                                )}
                                            </div>
                                        </div>
                                        <Divider />
                                        <div className="row">
                                            <div className="col-3"><strong>Duration:</strong></div>
                                            <div className="col-7">
                                                {new Date(data?.startDate).toDateString()} -  {new Date(data?.endDate).toDateString()}
                                                {excuseDutyDays(data?.startDate, data?.endDate) && (
                                                    <span className="ms-2"> ({excuseDutyDays(data?.startDate, data?.endDate)} {excuseDutyDays(data?.startDate, data?.endDate) === 1 ? 'day' : 'days'})</span>
                                                )}
                                            </div>
                                        </div>
                                        <Divider />

                                        <div className="row">
                                            <div className="col-3"><strong>Diagnosis:</strong></div>
                                            <div className="col-7">{data?.diagnosis}</div>
                                        </div>
                                        <Divider />
                                        <div className="row">
                                            <div className="col-3"><strong>Doctor's Comments:</strong></div>
                                            <div className="col-7">{data?.comment}</div>
                                        </div>
                                        <Divider />
                                        <div className="row">
                                            <div className="col-3"><strong>Doctor-In-Charge:</strong></div>
                                            <div className="col-7"><strong>{`${data?.doctor?.firstName} ${data?.doctor?.lastName}`}</strong></div>
                                        </div>
                                        <div className="row">
                                            <div className="col-3">Contact:</div>
                                            <div className="col-7">{data?.doctor?.contact}</div>
                                        </div>
                                        <div className="row">
                                            <div className="col-3">Date:</div>
                                            <div className="col-7">{new Date(data?.createdAt).toDateString()}</div>
                                        </div>
                                        {(data?.doctor?.signatureUrl || data?.doctor?.stampUrl) && (
                                            <div className="row mt-5">
                                                {data?.doctor?.signatureUrl && (
                                                    <div className="col-md-6 col-12 text-start">
                                                        <strong>Signature</strong>
                                                        <div className="mt-2">
                                                            <img
                                                                src={data.doctor.signatureUrl}
                                                                alt="Doctor signature"
                                                                style={{ maxWidth: "100%", maxHeight: 144, objectFit: "contain" }}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                                {data?.doctor?.stampUrl && (
                                                    <div className="col-md-6 col-12 text-start">
                                                        <strong>Stamp</strong>
                                                        <div className="mt-2">
                                                            <img
                                                                src={data.doctor.stampUrl}
                                                                alt="Doctor stamp"
                                                                style={{ maxWidth: "100%", maxHeight: 144, objectFit: "contain" }}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <div className="mt-4">
                                            <small>This excuse duty was generated from the CareOS: </small>
                                            <small>{new Date().toUTCString()}</small>
                                            <small className="d-block">for more information, visit {process.env.REACT_APP_WEBSITE}</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
            }
        </div >
    );
}
